import { EventVm } from '../utils/api';

/** Oldest first within one period and clock. Unnumbered overtime play precedes PSO. */
export const compareEventPosition = (a: Pick<EventVm, 'id' | 'shootoutOrder'>, b: Pick<EventVm, 'id' | 'shootoutOrder'>): number => {
    if ((a.shootoutOrder != null) !== (b.shootoutOrder != null)) return a.shootoutOrder != null ? 1 : -1;
    if (a.shootoutOrder != null && b.shootoutOrder != null && a.shootoutOrder !== b.shootoutOrder)
        return a.shootoutOrder - b.shootoutOrder;
    return a.id - b.id;
};
